import { render, staticRenderFns } from "./ReviewItemSubmit.vue?vue&type=template&id=161acf2e"
import script from "./ReviewItemSubmit.vue?vue&type=script&lang=ts"
export * from "./ReviewItemSubmit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports